/**
 * Vocabulario de blockers de publicación.
 *
 * La REGLA vive en el gate canónico del servidor
 * (`private.vehicle_listing_activation_blockers`, expuesta a la app por
 * `list_my_vehicle_listing_blockers`). Este archivo solo declara los códigos
 * que el servidor puede devolver y el helper de ruteo; NO re-implementa la
 * regla. Tener dos implementaciones fue exactamente el desacuerdo que esto
 * elimina: la app decía `insurance_qualitas`/`selfie` y no conocía `location`,
 * `price`, `catalog` ni `organization`.
 */

/**
 * Códigos del gate. Un código nuevo del servidor se pinta con el fallback
 * genérico de i18n (`hosting.blocker_generic`) hasta que se agregue su
 * etiqueta — nunca como token crudo en inglés.
 *
 * `publication` y `deleted` son estado, no tarea: la notificación los filtra y
 * la lista del app no los muestra.
 */
export type ListingBlocker =
  | 'identity'
  | 'photos'
  | 'tarjeta_front'
  | 'tarjeta_back'
  | 'insurance_platform'
  | 'insurance_own'
  | 'city'
  | 'location'
  | 'price'
  | 'catalog'
  | 'organization'
  | 'host_restricted'
  | 'insurance_model'

/** ¿Algún blocker se resuelve en Verificación (DUI + selfie)? */
export function listingBlockersNeedPersonal(blockers: readonly string[]): boolean {
  return blockers.includes('identity')
}
